export default "__VITE_ASSET__cc9d7994__"